import React, { useEffect, useState } from "react";
import { ArrowLeft } from "lucide-react";
import { reApi } from "@/lib/residentApi";
import { ResidentPicker } from "@/components/nds/windows/resident/ResidentPicker";
import MemoBoardTab from "@/components/nds/windows/resident/MemoBoardTab";
import { useAuth } from "@/lib/auth";
import { canEditCard } from "@/lib/placement";

export default function ReMemosContent({ win }) {
  const [res, setRes] = useState(null);
  const { user } = useAuth();
  const want = win?.payload?.residentId;
  useEffect(() => { if (want) reApi.get(`/residents/${want}`).then(setRes).catch(() => {}); }, [want, win?.payload?.nonce]);
  return (
    <div data-testid="re-memos-content" className="h-full overflow-y-auto p-5 space-y-4">
      {res ? (
        <>
          <button type="button" onClick={() => setRes(null)} data-testid="re-memos-back" className="inline-flex items-center gap-1 font-mono text-[10px] tracking-[0.22em] uppercase text-nex-gold"><ArrowLeft className="h-3.5 w-3.5" /> Residents</button>
          <h3 data-testid="re-memos-resident" className="text-lg font-semibold text-nex-silver">{res.first_name} {res.last_name}</h3>
          <MemoBoardTab key={res.id} resident={res} manage={canEditCard(user, "cap_re_memos")} />
        </>
      ) : <ResidentPicker prefKey="memos" onPick={setRes} testid="re-memos-picker" />}
    </div>
  );
}
